import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { get } from "lodash";

import Button from "@material-ui/core/Button";

import FrResults from "./FrResults";
import AddComment from "./AddComment";
import Verification from "./Verification";
import MeasuredTemperatureDialog from "../Temperature/MeasuredTemperatureDialog";

import {
  startTimeout,
  openCard,
  setOpen as setOpenAction,
} from "../../../actions/siteEntranceExit/liveEvents";

import { driveInOut, walkInOut } from "../../../constants/reducers";
import {
  frResults,
  comments,
  verifications,
  measuredTemperature,
} from "../../../constants/liveEvents";

import { liveEventTimeout } from "../../../utils/liveEvents";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  buttonIcon: {
    boxShadow: `0px 1px 2px 0px ${colors.black24}, 0px 1px 3px 0px ${colors.black12}`,
    padding: "0px !important",
    minWidth: "0px",
    "& img": {
      width: "32px",
    },
  },
};

const LiveCardAction = (props) => {
  const {
    dispatch,
    classes,
    section,
    zoneId,
    sessionId,
    action,
    actionProps,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [hadTimeout, setHadTimeout] = React.useState(false);

  let card;
  if (section === walkInOut) {
    card = get(props, [
      "siteEntranceExit",
      section,
      "liveEvents",
      zoneId,
      "events",
      sessionId,
    ]);
  } else if (section === driveInOut) {
    card = get(props, ["siteEntranceExit", section, "liveEvents", zoneId]);
  }

  // On open, clear running timeout if any
  const onOpen = () => {
    setOpen(true);
    if (card) {
      if (get(card, ["timeout"])) {
        setHadTimeout(true);
      }
      dispatch(openCard(section, zoneId, sessionId));
    }
  };

  // On close, restart timeout if there was any
  const onClose = () => {
    setOpen(false);
    if (card) {
      if (hadTimeout) {
        setHadTimeout(false);
        let timeout = setTimeout(
          () =>
            liveEventTimeout(
              dispatch,
              section,
              zoneId,
              sessionId,
              get(props, ["siteEntranceExit", section, "activeTab"])
            ),
          card.timer
        );
        dispatch(startTimeout(section, zoneId, timeout, sessionId));
      } else {
        dispatch(setOpenAction(section, zoneId, sessionId, false));
      }
    }
  };

  if (action === frResults) {
    console.log("actionPropsactionProps", actionProps)
    return (
      <FrResults
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        {...actionProps}
        triggerNode={
          <Button className={classes.buttonIcon}>
            <img
              src={
                actionProps.faceMatch ? images.frResultGreen : images.frResult
              }
              style={{ display: "block" }}
              alt="details"
            />
          </Button>
        }
        isLive={true}
      />
    );
  }

  if (action === comments) {
    return (
      <AddComment
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        {...actionProps}
      />
    );
  }

  if (action === verifications) {
    return (
      <Verification
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        section={section}
        zoneId={zoneId}
        sessionId={sessionId}
        {...actionProps}
      />
    );
  }

  if (action === measuredTemperature) {
    return (
      <MeasuredTemperatureDialog
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        {...actionProps}
      />
    );
  }

  return null;
};

LiveCardAction.propTypes = {
  section: PropTypes.oneOf([driveInOut, walkInOut]).isRequired,
  zoneId: PropTypes.number,
  sessionId: PropTypes.string,
  action: PropTypes.oneOf([
    frResults,
    comments,
    verifications,
    measuredTemperature,
  ]),
  actionProps: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    siteEntranceExit: state.siteEntranceExit,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(LiveCardAction));
